import React, { useState } from "react";
import { Form, Input, Button, Typography, Spin, message, Row, Col } from "antd";
import LeftLayout from "../../pageHeader/LeftLayout";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import { RightOutlined } from '@ant-design/icons';
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import _capitalProviderService from "../../../modules/capitalProviderService";


import HeaderComponentWithTitleAndLogo from "../../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../../components/MainLayout/MainLayout";
import SendOTP from "../../../components/SendOTP/SendOTP";

const { Title, Text, Link } = Typography;

const ForgotCapitalProviderLoginPasswordSendOTP = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const onFinish = async (values) => {
        let reqObj = {
            Email: values.email,
            Role: "capitalprovider"
        }
        setLoading(true);
        try {
            const res = await _capitalProviderService.forgotPasswordSendEmailOTP(reqObj);
            if (res.data.IsSuccess) {
                debugger
                message.success(res.data.Message || "OTP Sent Successfully");
                history.push({
                    pathname: routes.forgotCapitalProviderLoginPassword.path,
                    state: { "email": values.email }
                });
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    return (
        <Spin spinning={loading}>

            <MainLayout>
                <HeaderComponentWithTitleAndLogo
                    logoSrc="/websiteLogo.png"
                    logoAlt="Leveridge Logo"
                    title="Forgot Password"
                    // subtitle="Enter your email to receive OTP"
                />
                <SendOTP
                    onFinish={onFinish}
                    loading={loading}
                    goBackLinkLable="Login"
                    goBackLinkPath={() => history.push(routes.capitalProviderLogin.path)}
                />
            </MainLayout>
            {/* <LeftLayout>
                <div className="w450">
                    <Title level={3} style={{ marginBottom: 60 }}>
                        Capital Provider Portal
                    </Title>


                    <Form
                        name="verify-email"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Email address is required" },
                                {
                                    type: "email",
                                    message: "Please enter a valid email address",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Your Email" maxLength={50} />
                        </Form.Item>

                        <Text type="secondary" style={{ fontSize: 14 }}>
                            We will send an OTP to your email address for validation
                        </Text>

                        <Form.Item style={{ marginTop: 24 }}>
                            <Button
                                htmlType="submit"
                                size="large"
                                loading={loading}
                            >
                                Send OTP <RightOutlined />
                            </Button>
                        </Form.Item>
                    </Form>

                    <Row justify="space-between" style={{ marginTop: 32 }}>
                        <Col>
                            <Link onClick={() => history.push(routes.capitalProviderLogin.path)} style={{ fontWeight: "bold" }}>
                                Login <RightOutlined />
                            </Link>
                        </Col>
                    </Row>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default ForgotCapitalProviderLoginPasswordSendOTP;